<template>
  <select
      class="form-control"
      v-bind="{
      ...$attrs,
      onChange: updateValue
    }"
      :value="modelValue"
      :id="uuid"
      :aria-describedby="error ? `${uuid}-error` : null"
      :aria-invalid="error ? true : false"
      :class="{ error }"
  >
    <option value="">{{ placeholder || 'Select' }}</option>
    <option
        v-for="option in options"
        :value="option"
        :key="option"
        :selected="option === modelValue"
    >
      {{ option }}
    </option>
  </select>
  <ErrorMessage
      v-if="error"
      :id="`${uuid}-error`"
  >
    {{ error }}
  </ErrorMessage>
</template>

<script>
import SetupFormComponent from '@/Lib/SetupFormComponent'
import UniqueID from '@/Lib/UniqueID'

export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Select'
    },
    error: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [String, Number]
    }
  },
  setup (props, context) {
    const { updateValue } = SetupFormComponent(props, context)
    const uuid = UniqueID().getID()

    return {
      updateValue,
      uuid
    }
  }
}
</script>